import { NgModule } from '@angular/core';
import { TranslateCut } from './translate-cut.pipe';

@NgModule({
  declarations: [TranslateCut],
  exports: [TranslateCut],
})
export class CustomPipesModule {}
